// extracted by mini-css-extract-plugin
export var badge = "_gr-2";
export var detailsPanel = "_gr-0";
export var resultRow = "_gr-1";